// extracted by css-extract-rspack-plugin
var _1 = "BZeWz";
export { _1 as "view" }
